// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".FullScreenDialog__title {\n  flex: 0 1 auto;\n  overflow: hidden;\n}\n\n[dir='ltr'] .FullScreenDialog__title {\n  margin-right: auto;\n}\n\n[dir='rtl'] .FullScreenDialog__title {\n  margin-left: auto;\n}\n\n.FullScreenDialog__buttons {\n  height: 48px;\n  display: flex;\n  flex: 1 1;\n  justify-content: flex-end;\n}\n\n.FullScreenDialogContent {\n  padding: 24px 16px;\n}\n", ""]);
// Exports
module.exports = exports;
